import React, { useState } from 'react';
import PropType from 'prop-types';

// Atoms
import { Flex } from '../../Atoms/Flex-Grid';
import { Divider } from '../../Atoms/Dividers';
import {
	Radio, RadioViewBackground, RadioView, RadioWrapper, RadioLabel,
} from './RadioButton.atoms';

const RadioButton = ({
	                     options, name, onChange, initialState,
}) => {
	const [checkedOption, setCheckedOption] = useState(initialState);
	const handleOnChange = (option) => {
		onChange(option);
		setCheckedOption(option);
	};

	return (
		<form>
			{options?.map(option => (
				<div key={option}>
					<Flex justify="flex-start">
						<RadioWrapper>
							<Radio
								type="radio"
								id={option}
								name={name}
								value={option}
								onChange={() => handleOnChange(option)}
							/>
							<RadioView>
								<RadioViewBackground className={option === checkedOption && 'checked'} />
							</RadioView>
						</RadioWrapper>
						<Divider.VerticalDivider width="5" />
						<RadioLabel htmlFor={option}>{option}</RadioLabel>
					</Flex>
					<Divider.SmallMarginDivider />
				</div>
			))}
		</form>
	);
};

RadioButton.defaultProps = {
	initialState: null,
};

RadioButton.propTypes = {
	options: PropType.arrayOf(PropType.oneOfType([PropType.string, PropType.number])).isRequired,
	name: PropType.string.isRequired,
	onChange: PropType.func.isRequired,
	initialState: PropType.string,
};

export default RadioButton;
